export default {
    cancel: 'Cancel',
    contactSupport: `Please contact support.`,
    delete: 'Delete',
    exit: 'Exit',
    or: 'or',
    searching: 'Searching',
    archive: `Archive`
}
